module.exports = __webpack_public_path__ + "img/box_green.44ad3d5f.png";